import React, {Component}    from 'react'
import BlockUi               from 'react-block-ui'
import { message }           from 'antd'

import CloudFlyerAPI          from '../../../api/CloudFlyerAPI'
import {get_previous_path} from "../../../utils"

import Header              from '../../Fs/Controls/header'
import NavigationControls  from '../Controls/navigation-controls'
import CreateFolder        from '../Controls/create-folder'
import Files               from './files'

import 'react-block-ui/style.css'
import './styles.scss'

export default class FtxFilesSystem extends Component {

    constructor (props) {
        super(props)
        this.side = props.side
        this.state = {
            files              : [],
            files_loading      : true,

            previous_path      : null,
            current_path       : '/',

            create_folder      : false,
            new_folder_name    : '',

            files_error        : null,
            new_folder_error   : null,
            delete_error       : null,

            new_folder_loading : false,
            transfer_loading   : false,

            selection : {
                size       : 0,
                cost       : 0.0003,
                total_cost : 0,
                count      : 0
            },

            launch_attempt        : 0,
            launch_loading        : false,
            is_agent_running      : true,
            transfer_server_error : null,
            server_connected      : null,
            limit                 : 100
        }
    }

    componentDidMount() {
        this.on_refresh()
    }

    componentWillReceiveProps({cloud:{account_type_id}={}}={}){
        if(this.state.server_connected && account_type_id !== this.state.server_connected)
            this.setState({server_connected: null})
    }

    on_refresh = () =>{
        let $this = this
        this.setState({files_loading:true})
        let {limit, skip, current_path, server_connected} = this.state

        CloudFlyerAPI
            .ftx
            .files(current_path, skip, limit)
            .then(res =>
                $this.setState({
                    files: ((res||{}).data||{}).items.map(f => ({
                        name: f.name,
                        path: f.path,
                        size: (f.size === -1 ? null : f.size)
                    })), files_loading: false,
                    previous_path: get_previous_path(current_path),
                    is_agent_running:true
                }, () => {
                     this.props.on_browse(current_path)
                    !server_connected && CloudFlyerAPI
                        .ftx.connect().then(()=>$this.setState({server_connected:true}))
                }))
            .catch(()=>
                this.setState({is_agent_running: false, files_loading: false, server_connected: false}, () =>
                    !server_connected && CloudFlyerAPI
                        .ftx.connect().then(() => $this.setState({server_connected: true}))))
    }

    on_delete = file =>{
        let $this = this

        let file_names = []

        if(file && !file.checked){
            file_names.push(file.path)
        } else {
            for (let i = 0; i < this.state.files.length; i++) {
                let fl = this.state.files[i];
                if(fl.checked){
                    file_names.push(fl.path)
                }
            }
        }

        $this.setState({
            delete_loading: true
        })

        CloudFlyerAPI.file_catalyst
            .files
            .delete_file(file_names[0])
            .then(() =>{
                $this.setState({
                    delete_loading : false
                }, ()=> $this.on_refresh())
            })
            .catch(e =>{
                $this.setState({delete_loading:false, delete_error : e})
                message.error(e.message)
            })
    }

    on_navigate_back = () => this.setState({current_path: this.state.previous_path}, () => this.on_refresh())

    on_navigate = file => this.setState({current_path: file.path}, () => this.on_refresh())

    on_select = (file, checked) =>{
        for (let key in this.state.files) {
            let item = this.state.files[key]
            if(item.path === file.path && item.size){
                item.checked = checked
                this.setState({
                    files : this.state.files,
                    selection_count:this.state.files.filter(_=>_.checked).length
                }, ()=> {
                    this.props.file_selection_changed && this.props.file_selection_changed(this.state.files)
                    //this.props.cloud_selection_changed(this.calculate_selection())
                })
                return
            }
        }
    }

    on_create_folder = new_folder_name => {
        let $this = this

        if(!new_folder_name){
            return this.setState({
                create_folder : true
            })
        }

        this.setState({
            new_folder_loading : true
        })

        CloudFlyerAPI.file_catalyst
            .files
            .create_directory(this.state.current_path + '/' + new_folder_name)
            .then(() =>{
                $this.setState({
                    new_folder_loading : false,
                    create_folder : false
                }, ()=> $this.on_refresh())
            })
            .catch(e =>{
                console.error(e)
                $this.setState({new_folder_loading:false, new_folder_error : e})
                message.error(e.message)
            })
    }

    on_cancel_create_folder = () =>
        this.setState({
            create_folder: false
        })

    on_new_folder_name_change = new_folder_name => this.setState({new_folder_name: new_folder_name})

    save_ref = form => this.form = form

    on_launch_agent = ()=> {
        let $this = this
        $this.setState({
            launch_attempt : this.state.launch_attempt++,
            launch_loading : true
        })

        CloudFlyerAPI
            .ftx
            .launch()
            .then(()=> new Promise(_ => setTimeout(_, 1000)))
            .then(CloudFlyerAPI.ftx.connect)
            .then(()=> $this.setState({is_agent_running: true, launch_loading: false, transfer_server_error: null}))
            .catch(err=> $this.setState({
                is_agent_running: false,
                launch_loading: false,
                transfer_server_error: err.message
            }))
    }

    add_files = (items=[], index) =>{
        let files = this.state.files
        files.splice(index, 0, ...items)
        for (let key in files) {
            if(items.some(e => e.path === files[key].path))
            {
                files[key].pasted = true
                files[key].checked = false
            } else
                files[key].pasted = files[key].checked = false
        }
        this.setState({files}, ()=> this.props.file_selection_changed && this.props.file_selection_changed(this.state.files))
    }

    remove_files = (items=[]) =>{
        let files = this.state.files
        for (let key in files) {
            if(items.some(e => e.path === files[key].path))
                delete files[key]
        }
        this.setState({files}, ()=> this.props.file_selection_changed && this.props.file_selection_changed(this.state.files))
    }

    reorder = (items=[], index, index_dest) =>{
        let files = this.state.files
        for (let key in files) {
            if(items.some(e => e.path === files[key].path))
            {
                const [removed] = files.splice(index, 1)
                files.splice(index_dest, 0, removed)
            }
        }
        this.setState({files})
    }

    render() {
        const {transfer_loading, files_loading, launch_loading, is_agent_running, files=[], selection_count, previous_path} = this.state
        const {block_ui, dragging_id, is_drop_disabled, is_drag_disabled} = this.props

        return (
            <BlockUi className='ftx-files-system' blocking={transfer_loading || files_loading || block_ui}>

                <Header title={'Local Files'}
                        files             = {this.state.files}
                        show_download_ftx={!this.state.files.length}
                        on_refresh      = {this.on_refresh.bind(this)}/>

                <hr/>

                <NavigationControls
                    key              = {'NavigationControls'}
                    files_loading    = {files_loading}
                    previous_path    = {previous_path}
                    files            = {files}
                    on_navigate_back = {this.on_navigate_back.bind(this)}
                />

                <hr/>

                {this.state.create_folder ?
                    ([<CreateFolder key={'CreateFolder'}
                                    new_folder_name  = {this.state.new_folder_name}
                                    on_create_folder = {this.on_create_folder.bind(this)}
                                    on_change        = {this.on_new_folder_name_change.bind(this)}
                                    on_cancel        = {this.on_cancel_create_folder.bind(this)}/>, <hr key={'hr'}/>])  : null}

                <Files
                    key                = {'Files'}
                    files              = {files}
                    files_loading      = {files_loading || launch_loading}
                    is_agent_running   = {is_agent_running}
                    any_cloud_accounts = {this.state.cloud_accounts}
                    accounts_loading   = {this.props.any_cloud_accounts}

                    on_delete       = {this.on_delete.bind(this)}
                    on_select       = {this.on_select.bind(this)}
                    on_refresh      = {this.on_refresh.bind(this)}
                    on_navigate     = {this.on_navigate.bind(this)}
                    on_launch_agent = {this.on_launch_agent}

                    droppable_id      = {this.side || Math.random()}
                    is_drop_disabled  = {is_drop_disabled}
                    is_drag_disabled  = {is_drag_disabled}
                    selection_count   = {selection_count}
                    dragging_id       = {dragging_id}
                    has_more          = {this.state.has_more}

                    on_play_video     = {this.on_play_video}
                    on_share          = {this.on_share}
                    on_open_encode    = {this.on_open_encode}
                    on_show_media_info= {this.on_show_media_info}
                    on_expand_options = {this.on_expand_options}
                    on_move           = {this.on_move_files}
                    on_load_more      = {this.on_load_more}
                />

            </BlockUi>
        )
    }
}
